module.exports = __webpack_public_path__ + "static/media/react_logo.35fb878d.png";